module.exports = __webpack_public_path__ + "img/AUDUSD.28abd45e.png";